module.exports = __webpack_public_path__ + "static/media/UCalgary.1fe9c1ca.svg";